import React from 'react'
import { usePrepareCart } from 'hooks/usePrepareCart'
import { CardProduct } from './cardProduct'
import * as Style from './styles'
import useMediaQuery from '../../../hooks/useMediaQuery'
import { MOBILE_WIDTH } from '../../../utils/constants'

interface iProductList {
  isNotEditingFlavor?: boolean
  isNotEditing?: boolean
  modal?: boolean
  productList?: any
  isCarrinhoWa?: boolean
  excludeIds?: Set<number>
}
function ProductList({ isNotEditing, modal, productList, isNotEditingFlavor, isCarrinhoWa, excludeIds }: iProductList) {
  const { lastOrderCreated } = usePrepareCart()
  const isMobile = useMediaQuery(MOBILE_WIDTH)
  const allProducts = productList || lastOrderCreated?.items
  const products = excludeIds?.size
    ? allProducts.filter((p: any) => !excludeIds.has(Number(p?.product_id || p?.product?.id || p?.id)))
    : allProducts

  return (
    <>
      {!isMobile && (
        <Style.TableHeader>
          <div className="product">
            <p>produto</p>
          </div>
          <div className="product-properties">
            <p>quantidade</p>
            <p className="sabor">sabor</p>
            <p>valor unitário</p>
            <p>valor total</p>
          </div>
        </Style.TableHeader>
      )}
      <Style.Products>
        {products
          .sort((a: any, b: any) => (b.product_id > a.product_id ? 1 : -1))
          .map((product: any, index: any) => (
            <>
              {index > 0 && isMobile && <Style.Line />}
              <CardProduct
                isNotEditingFlavor={isNotEditingFlavor}
                product={product}
                isNotEditing={isNotEditing}
                isCarrinhoWa={isCarrinhoWa}
                key={product?.id}
              />
            </>
          ))}
      </Style.Products>
    </>
  )
}

export default ProductList
